import { icon } from "../icons.js";
import { guestsSummary } from "./searchbar.js";

// Модалка «Гости» (ref_4): степперы взрослых и детей.
// Возраст «ребёнка» — из getHotelParams через /api/config (guests.childMaxAge), не хардкодим:
// null → подписи возраста скрываются.
export function renderGuestsModal(state) {
  const g = state.config?.guests ?? {};
  const { adults, children } = state.guests;
  const maxCap = g.maxRoomCapacity ?? 6;
  const adultsSub = g.childMaxAge != null ? `${g.childMaxAge + 1}+ лет` : "";
  const childrenSub = g.childMaxAge != null ? `${g.childMinAge ?? 0}–${g.childMaxAge} лет` : "";

  const stepper = (kind, value, min, max) => `
    <span class="okb-stepper">
      <button type="button" data-okb="${kind}-minus" aria-label="Меньше" ${value <= min ? "disabled" : ""}>−</button>
      <b>${value}</b>
      <button type="button" data-okb="${kind}-plus" aria-label="Больше" ${value >= max ? "disabled" : ""}>+</button>
    </span>`;

  return `
  <div class="okb-modal okb-narrow" role="dialog" aria-modal="true" aria-label="Гости">
    <div class="okb-mhead">
      <div><h3>Гости</h3><p>Укажите количество гостей в номере</p></div>
      <button type="button" class="okb-mclose" data-okb="close-modal" aria-label="Закрыть">${icon("close")}</button>
    </div>
    <div class="okb-guestrow">
      <span class="okb-glabel"><b>Взрослые</b>${adultsSub ? `<small>${adultsSub}</small>` : ""}</span>
      ${stepper("ad", adults, 1, maxCap)}
    </div>
    <div class="okb-guestrow">
      <span class="okb-glabel"><b>Дети</b>${childrenSub ? `<small>${childrenSub}</small>` : ""}</span>
      ${stepper("ch", children, 0, Math.max(0, maxCap - adults))}
    </div>
    <div class="okb-mfoot">
      <div class="okb-mstatus">${guestsSummary(state.guests)}</div>
      <button type="button" class="okb-primary" data-okb="close-modal">Продолжить</button>
    </div>
  </div>`;
}
